import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './Auth/login/login.component';
import { AuthGuard } from 'src/Core/auth.guard';
import { UserRole, which_permission } from 'src/Core/Constant';


const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./Auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'admin',
    loadChildren: () => import('./Admin/admin.module').then((m) => m.AdminModule),
    canActivate: [AuthGuard],
    data: {
      permissions: ['can_see_list'], // Required permissions
      element: [UserRole.SuperAdmin], // Array of roles
    },
  },
  {
    path: 'applicant',
    loadChildren: () => import('./Applicant/applicant.module').then(m => m.ApplicantModule),
    canActivate: [AuthGuard],
    data: {
      permissions: [which_permission.can_see_list], // Define the required permission
      element: [UserRole.SuperAdmin, UserRole.Applicant,UserRole.APP,UserRole.COC,UserRole.GAO,UserRole.FirstAid,UserRole.SevaCenter,UserRole.HR], // Array of roles // Capitalized element key for more granular access control    
    }
  },
  {
    path: 'coc',
    loadChildren: () => import('./COC/coc.module').then(m => m.CocModule),
    canActivate: [AuthGuard],
    data: {
      permissions: [which_permission.can_see_list], // Define the required permission
      element: [UserRole.SuperAdmin, UserRole.COC,] // Capitalized element key for more granular access control    
    }
  },
  {
    path: 'app',
    loadChildren: () => import('./ApplicationPointPerson/application-point-person.module').then(m => m.ApplicationPointPersonModule),
    canActivate: [AuthGuard],
    data: {
      permissions: [which_permission.can_see_list], // Define the required permission
      element: [UserRole.SuperAdmin, UserRole.APP,] // Capitalized element key for more granular access control    
    }
  },
  {
    path: 'gao',
    loadChildren: () => import('./GAO/gao.module').then(m => m.GaoModule),
    canActivate: [AuthGuard],
    data: {
      permissions: [which_permission.can_see_list], // Define the required permission
      element: [UserRole.SuperAdmin,UserRole.GAO,] // Capitalized element key for more granular access control    
    },
    
  }, 
   {
    path: 'firstAid',
    loadChildren: () => import('./FIRST_AID/first-aid.module').then(m => m.FirstAidModule),
    canActivate: [AuthGuard],
    data: {
      permissions: [which_permission.can_see_list], // Define the required permission
      element: [UserRole.SuperAdmin,UserRole.FirstAid,] // Capitalized element key for more granular access control    
    },
    
  },
  {
    path: 'seva-center',
    loadChildren: () => import('./Seva-Center/seva-center.module').then(m => m.SevaCenterModule),
    canActivate: [AuthGuard],
    data: {
      permissions: [which_permission.can_see_list], // Define the required permission
      element:[UserRole.SuperAdmin, UserRole.SevaCenter, ]// Capitalized element key for more granular access control    
    },
    
  },

  {
    path: 'hr',
    loadChildren: () => import('./HR/hr.module').then(m => m.HrModule),
    canActivate: [AuthGuard],
    data: {
      permissions: [which_permission.can_see_list], // Define the required permission
      element:[UserRole.SuperAdmin, UserRole.HR, ]// Capitalized element key for more granular access control    
    },
    
  },

  // { path: '', redirectTo: '', pathMatch: 'full',component:LoginComponent },
  { 
    path: 'unauthorized', 
    loadChildren: () => import('./unauthorized/unauthorized.module').then(m => m.UnauthorizedModule) 
  },
  { path: '**', redirectTo: 'unauthorized', pathMatch: 'full' },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
